export default "__VITE_ASSET__D6Qk9icl__";